/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export const blobTypeStream = "application/octet-stream";
export const blobTypeCsv = "text/csv";
export const download = "download";
export const href = "href";
